import { crudService } from '../_services';
import { history } from '../_helpers';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';
import { stringUtils } from '../_utils';
import { parametrosAguaAction } from '../_actions';

export const parametrosAguaFaixaAction = {
    getParametroAguaFaixa,
    getParametroAguaFaixaById,
    onChangeProps,
    editParametroAguaFaixaInfo,
    createParametroAguaFaixa,
    deleteParametroAguaFaixaById,
    clear
};

let filterModel = {
    Page: 1,
    Limit: 10,
    Term: ''
};

function getParametroAguaFaixa(filterModel) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'parametrosAguaFaixa' + stringUtils.serialize(filterModel);
        crudService.get(apiEndpoint)
            .then((response) => {
                if (response.data) {
                    dispatch(changeParametrosAguaFaixasList(response.data.items, response.data.totalPages));
                }
                alerts.clean();
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function createParametroAguaFaixa(payload) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'parametrosAguaFaixa/';
        crudService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());

                    // refresh parent
                    dispatch(parametrosAguaAction.getParametrosAguaById(payload.idParametroAgua));

                    history.push(ret.path);
                    alerts.success(ret.message);
                    clear();
                } else {
                    alerts.warning(response.request.responseText);
                }
            });
    };
}
function getParametroAguaFaixaById(id) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'parametrosAguaFaixa/' + id;
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(editParametrosAguaFaixasDetails(response.data));
                alerts.clean();
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function onChangeProps(props, event) {
    return dispatch => {
        if (event.target.type === 'checkbox') {
            dispatch(handleOnChangeProps(props, event.target.checked));
        } else {
            dispatch(handleOnChangeProps(props, event.target.value));
        }
    };
}
function editParametroAguaFaixaInfo(id, payload) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'parametrosAguaFaixa/' + id;
        crudService.put(apiEndpoint, payload)
            .then((response) => {
           //     console.log(response);
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    history.push(ret.path);
                    getParametroAguaFaixa("");

                    // refresh parent
                    dispatch(parametrosAguaAction.getParametrosAguaById(payload.idParametroAgua));

                    alerts.success(ret.message);
                    clear();
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function deleteParametroAguaFaixaById(id) {
    return dispatch => {

        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir o registro?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
            .then((willDelete) => {
                if (willDelete.value) {

                    alerts.waiting();
                    let apiEndpoint = 'parametrosAguaFaixa/' + id;
                    crudService.deleteDetail(apiEndpoint)
                        .then((response) => {
                            if (response.request.status === 200) {
                                var ret = JSON.parse(response.request.responseText);
                                dispatch(deleteParametrosAguaFaixasDetails());
                                dispatch(getParametroAguaFaixa(filterModel));

                                // refresh parent
                                dispatch(parametrosAguaAction.getParametrosAguaById(ret.key));

                                alerts.success(ret.message);
                                clear();
                            } else {
                                alerts.warning(response.request.responseText);
                            }
                        }).catch((err) => {
                            console.log(err);
                            alerts.error(err);
                        });

                }
            });

    };
}
export function changeParametrosAguaFaixasList(parametroAguaFaixa, totalPages) {
    return {
        type: "FETECHED_ALL_PARAMETRO_AGUA_FAIXA",
        parametroAguaFaixa: parametroAguaFaixa,
        totalPages: totalPages
    };
}
export function clear() {
    return {
        type: "PARAMETRO_AGUA_FAIXA_CLEAR"
    };
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE_PARAMETRO_AGUA_FAIXA",
        props: props,
        value: value
    };
}
export function editParametrosAguaFaixasDetails(parametroAguaFaixa) {
    return {
        type: "PARAMETRO_AGUA_FAIXA_DETAIL",
        id: parametroAguaFaixa.id,
        nome: parametroAguaFaixa.nome,
        cor: parametroAguaFaixa.cor,
        faixaInicial: parametroAguaFaixa.faixaInicial,
        faixaFinal: parametroAguaFaixa.faixaFinal,
        idParametroAgua: parametroAguaFaixa.idParametroAgua,
        excluido: parametroAguaFaixa.excluido
    };
}
export function updatedUserInfo() {
    return {
        type: "PARAMETRO_AGUA_FAIXA_UPDATED"
    };
}
export function createUserInfo() {
    return {
        type: "PARAMETRO_AGUA_FAIXA_CREATED_SUCCESSFULLY"
    };
}
export function deleteParametrosAguaFaixasDetails() {
    return {
        type: "DELETED_PARAMETRO_AGUA_FAIXA_DETAILS"
    };
}